import * as React from "react";

import {Project} from "../../../../domain/model/project";
import {TCompanyWithProjectID} from "../../../../domain/repository/company_repository";
import {TBreadcrumbItem, TPagination} from "../../../type/common";

import Progress from "../../../common/organism/progress";

import CustomerEntryMain from "./customer_entries_main";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import {ProjectsEmpty} from "../../../../config/view_const/projects";
import EmptyData from "../../../common/organism/empty_data";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import {routeConfig} from "../../../../config/language/ja-JP/presentation/route_text";
import {User} from "../../../../domain/model/user";
import {Contract} from "../../../../domain/model/contract";
import Faq from "../../faq";

interface IProps {
    isInit: boolean;
    isLoading: boolean;
    projects: Project[];
    projectCount: number;
    companiesWithProjectID: TCompanyWithProjectID[];
    paginationPrams: TPagination;
    user: User | null;
    contractIndex: { [key: string]: Contract | null };
}

const EntriesComponent: React.FC<IProps> = (props) => {
    const {
        isInit,
        isLoading,
        projects,
        projectCount,
        companiesWithProjectID,
        paginationPrams,
        user,
        contractIndex,
    } = props;

    // 初期化
    if (isInit) {
        return <Progress canAnimation={false}/>;
    }

    const breadcrumbItems: TBreadcrumbItem[] = [
        routeConfig.customerRoot,
        routeConfig.customerEntries,
    ];

    return (
        <React.Fragment>
            {isLoading && <Progress canAnimation={false}/>}
            <PageWrapper>
                <Breadcrumbs breadcrumbItems={breadcrumbItems}/>

                <Faq title={"成約報告"}
                     text={"EXPERT NETWORK経由で成約した案件は、メッセージルーム内の案件カードから成約報告が必要です。フォームに契約内容を入力して送信することで完了となります。"}
                     link={
                         "https://branch-saturn-9ef.notion.site/178b91fe393e8031b6a2e41bffe0b505"
                     }/>


                {projectCount === 0 && (
                    <EmptyData
                        main={ProjectsEmpty.projectsForCustomerEntriesMain}
                        description={ProjectsEmpty.projectsForCustomerEntriesDescription}
                        linkUrl={`/customer/projects`}
                        btnText={ProjectsEmpty.projectsForCustomerEntriesBtnText}
                    />
                )}
                {projectCount > 0 && (
                    <CustomerEntryMain
                        projects={projects}
                        companiesWithProjectID={companiesWithProjectID}
                        paginationPrams={paginationPrams}
                        user={user}
                        contractIndex={contractIndex}
                    />
                )}
            </PageWrapper>
        </React.Fragment>
    );
};

export default EntriesComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/customer/entries/customer_entries.tsx